// import React, { Suspense } from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';



// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <Suspense fallback="...loading">
//             <App />
//         </Suspense>
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals


// import React, { Suspense } from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import './i18n.js'
// import Spinner from './Spinner';
// import "./Spinner.css"

// ReactDOM.render(
// 	<React.StrictMode>
// 		<Suspense fallback={
// 		<>
// 		<div>
// 		<Spinner/>
// 		<h1 className='loading' style={{marginLeft:"15%",alignSelf:"center"}}> Loading ! Please wait ... </h1>
// 		</div>
// 		</>
// 		}>
// 			<App />
// 		</Suspense>
// 	</React.StrictMode>,
// 	document.getElementById('root')
// );


import React, { Suspense } from 'react';
import ReactDOM from "react-dom/client";
import "./index.css";
import './i18n.js'
import Spinner from './Spinner';
import "./Spinner.css"
import App from './App';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={
		<>
		<div>
		<Spinner/>
		<h1 className='loading' style={{marginLeft:"15%",alignSelf:"center"}}> Loading ! Please wait ... </h1>
		</div>
		</>
		}>
			<App />
		</Suspense>
  </React.StrictMode>
);

